import axios from 'axios'
import BaseModel from '@/models/BaseModel.js'

export default class Stock extends BaseModel {
  fields =  {
    'nama': {
      label: 'Nama',
      type: 'text',
      rules: 'required'
    },
    'berat': {
      skipPriceTag: true,
      label: 'Berat (gram)',
      type: 'price',
      rules: 'required'
    },
    'kadar': {
      type: 'text',
      rules: 'required'
    },
    'jenis_barang': {
      label: 'Jenis Barang',
      type: 'enum',
      options: {
        'emas': 'Emas',
        'berlian': 'Berlian',
        'perhiasan': 'Perhiasan'
      },
      value: 'emas',
      rules: 'required'
    },
    'foto': {
      type: 'image',
      rules: null
    },
    'harga_modal': {
      type: 'price',
      rules: null
    },
    'harga_jual': {
      type: 'price',
      rules: null
    },
    'opening_quantity': {
      label: 'Jumlah Stok Awal (Buah)',
      type: 'number',
      rules: 'min_value:0',
      value: 0
    },
  }
  endpoint = process.env.VUE_APP_API_URL + 'stocks'

  create (value) {
    const formData = this.initForEndpoint(value)
    if (value.approval_status) formData.append('approval_status', value.approval_status)
    return axios.post(this.endpoint, formData).then(response => response.data)
  }

  findByBarcode (params = {}) {
    return new Promise((resolve, reject) => {
      const url = new URL(this.endpoint)
      const urlParams = new URLSearchParams(url.search)
      Object.keys(params).forEach(key => {
        if (typeof params[key] === 'string' || typeof params[key] === 'number') {
          urlParams.append(key, params[key])
        }
      })
      axios.get(this.endpoint + (Object.keys(params).length ? '?' + urlParams.toString() : '')).then(response => {
        return resolve(
          response.data.data ? response.data.data[0] : null
        )
      }).catch(error => {
        reject(error)
      })
    })
  }

  submit (id) {
    return axios.patch(this.endpoint + '/' + id + '/submit').then(response => response.data)
  }

  approve (id, reviewNote = null) {
    return axios.patch(this.endpoint + '/' + id + '/approve', { review_note: reviewNote }).then(response => response.data)
  }

  returnForRevision (id, reviewNote) {
    return axios.patch(this.endpoint + '/' + id + '/return', { review_note: reviewNote }).then(response => response.data)
  }

  reject (id, reviewNote) {
    return axios.patch(this.endpoint + '/' + id + '/reject', { review_note: reviewNote }).then(response => response.data)
  }

  restore (id) {
    return axios.patch(this.endpoint + '/restore/' + id).then(response => response.data)
  }
}
